<template>
    <div class="operation_box">
		<div class="operation_item">
			<el-dropdown split-button type="primary"
						 @click="displayModal"
						 @command="(command) => command()"
			>
				<i class="fa fa-pencil"></i>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item icon="fa fa-pencil" :command="displayModal">
						<span>{{ $t("common.edit") }}</span>
					</el-dropdown-item>
					<el-dropdown-item icon="fa fa-trash-o" :command="deleteRating">
						<span>{{ $t("common.delete") }}</span>
					</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</div>
    </div>
</template>

<script>
export default {
    methods: {
		displayModal() {
			this.params.showEditModal(this.params.data.ratedCompanyId);
        },
	    deleteRating() {
		    this.params.deleteRating(this.params.data.ratedCompanyId);
	    }
    }
};
</script>